import { useState, useEffect, useRef } from 'react';

/**
 * Custom Hook für Scroll-basierte Animationen
 * @param {Object} options - Konfigurationsoptionen
 * @param {number} options.threshold - Prozentsatz des Elements, der sichtbar sein muss (0-1)
 * @param {number} options.triggerOnce - Ob die Animation nur einmal ausgelöst werden soll
 * @param {number} options.rootMargin - Margin für den Intersection Observer
 */
const useScrollAnimation = (options = {}) => {
  const {
    threshold = 0.2,
    triggerOnce = true,
    rootMargin = '0px'
  } = options;

  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (triggerOnce && elementRef.current) {
            observer.unobserve(elementRef.current);
          }
        } else if (!triggerOnce) {
          setIsVisible(false);
        }
      },
      {
        threshold,
        rootMargin
      }
    );

    const currentElement = elementRef.current;
    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, [threshold, triggerOnce, rootMargin]);

  return [elementRef, isVisible];
};

export default useScrollAnimation;

